import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import BadgeStar from '../shared/BadgeStar'

export default function BadgeBlock({ athleteId, onViewAll }) {
  const [earnedBadges, setEarnedBadges] = useState([])
  const [totalBadges, setTotalBadges] = useState(27)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!athleteId) return
    fetchBadges()
  }, [athleteId]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchBadges = async () => {
    setLoading(true)

    const { data } = await supabase
      .from('athlete_badges')
      .select('*, badges(*)')
      .eq('athlete_id', athleteId)

    setEarnedBadges(data || [])

    const { count } = await supabase
      .from('badges')
      .select('id', { count: 'exact', head: true })
    setTotalBadges(count || 27)

    setLoading(false)
  }

  return (
    <div style={{
      width: '100%', height: '100%',
      display: 'flex', flexDirection: 'column',
      padding: '0.5rem', boxSizing: 'border-box'
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: '0.5rem'
      }}>
        <div style={{ color: '#facc15', fontWeight: 'bold', fontSize: '0.85rem' }}>
          🏆 Achievement
        </div>
        <div style={{ color: '#94a3b8', fontSize: '0.7rem' }}>
          {loading ? '...' : `${earnedBadges.length}/${totalBadges}`}
        </div>
      </div>

      <div style={{
        display: 'flex', flexWrap: 'wrap',
        gap: '4px', justifyContent: 'center',
        flex: 1, alignContent: 'center'
      }}>
        {loading ? (
          <div style={{ color: '#94a3b8', fontSize: '0.75rem' }}>Loading...</div>
        ) : (
          <>
            {earnedBadges.slice(0, 6).map(ab => (
              <BadgeStar
                key={ab.id}
                size={36}
                color={ab.badges?.color || '#facc15'}
                earned={true}
                icon={ab.badges?.icon || '⭐'}
                name={ab.badges?.name || ''}
              />
            ))}
            {/* Tampilkan slot kosong sampai 9 */}
            {Array.from({ length: Math.max(0, 9 - earnedBadges.length) }).map((_, i) => (
              <BadgeStar
                key={`empty-${i}`}
                size={36}
                color='#94a3b8'
                earned={false}
                icon='?'
                name='???'
              />
            ))}
          </>
        )}
      </div>

      <div
        onClick={onViewAll}
        style={{
          textAlign: 'center', color: '#facc15',
          fontSize: '0.7rem', cursor: 'pointer',
          marginTop: '0.25rem', opacity: 0.8
        }}
      >
        Lihat semua →
      </div>
    </div>
  )
}

